<template>
  <a
    :href="href"
    v-bind="$attrs"
    :class="['zg-button-link', {
      'zg-button-link--full-width': buttonProps && buttonProps.fullWidth,
      'zg-button-link--full-width-mobile': buttonProps && buttonProps.fullWidthMobile
    }]"
  >
    <zg-button v-bind="buttonProps">
      {{ text }}
    </zg-button>
  </a>
</template>

<script>
  import ZgButton from '../ZgButton/ZgButton.vue'

  export default {
    name: 'ZgButtonLink',
    components: {
      ZgButton
    },
    props: {
      href: {
        type: String,
        required: true
      },
      text: {
        type: String,
        required: true
      },
      buttonProps: {
        type: Object,
        default: () => {}
      }
    }
  }
</script>

<style lang="scss" scoped>
  .zg-button-link {
    display: inline-block;
    border-bottom: none;

    &--full-width {
      width: 100%;
    }

    &--full-width-mobile {
      @include mq($until: medium) {
        width: 100%;
      }
    }
  }
</style>
